<p-table #dt [value]="valuesInternal" [paginator]="paginator" [rows]="rows" [globalFilterFields]="['item']" [alwaysShowPaginator]="false" styleClass="p-datatable-striped p-datatable-sm">
  <ng-template pTemplate="caption" *ngIf="displayFiltre">
    <div style="width: 100%">
      <i class="fa fa-search" style="margin: 4px 4px 0 0"></i>
      &nbsp;
      <input type="text" pInputText placeholder="Filtre global" (input)="dt.filterGlobal($any($event.target).value, 'contains')" style="width: calc(100% - 40px); display: inline" class="form-control form-control-sm ui-inputtext" />
    </div>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="readonly ? 1 : 2" style="text-align: center">
        {{ texteAucun }}
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th pResizableColumn [pSortableColumn]="'item'" class="cropText">
        {{ texteNomColonne }}
        <span class="badge badge-pill badge-info" *ngIf="values && values.length > 0" [pTooltip]="texteNombreDe + ' : ' + (values ? values.length : '0')">{{ values.length }}</span>
        <p-sortIcon [field]="'item'"></p-sortIcon>
      </th>
      <th style="width: 220px" pResizableColumn *ngIf="!readonly">
        <button type="button" class="btn btn-sm btn-link" (click)="addValue()"><i class="fa fa-plus" aria-hidden="true"></i>&nbsp;{{ texteAjouter }}</button>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-value let-ri="rowIndex">
    <tr class="row-selection" (dblclick)="readonly ? edit(value) : false" [ngClass]="{ 'row-selection': !readonly }">
      <td class="ui-resizable-column" *ngIf="!value.editing">{{ value.item }}</td>
      <td class="ui-resizable-column" *ngIf="value.editing">
        <input type="text" class="form-control form-control-sm ui-inputtext" name="nom{{ ri }}" id="nom{{ ri }}" [(ngModel)]="values[ri]" autocomplete="off" [maxlength]="maxlength" (keyup.enter)="save(ri, $event)" (keyup.escape)="cancel(value)" />
      </td>
      <td class="ui-resizable-column" style="text-align: center" *ngIf="!readonly">
        <button type="button" class="btn btn-sm btn-link btn-discret btn-space-right" (click)="edit(value)" title="Editer" *ngIf="!value.editing"><i class="fa fa-pencil" aria-hidden="true"></i></button>
        <button type="button" class="btn btn-sm btn-link btn-discret btn-link-success btn-space-right" (click)="save(ri, $event)" *ngIf="value.editing"><i class="fa fa-check" aria-hidden="true"></i></button>
        <button type="button" class="btn btn-sm btn-link btn-discret btn-link-danger btn-space-right" (click)="cancel(ri)" *ngIf="value.editing"><i class="fa fa-times" aria-hidden="true"></i></button>
        <button type="button" class="btn btn-sm btn-link btn-discret btn-link-danger btn-space-right" (click)="delete(ri)" title="Supprimer" *ngIf="!value.editing"><i class="fa fa-trash" aria-hidden="true"></i></button>
      </td>
    </tr>
  </ng-template>
</p-table>
